import { loader } from 'graphql.macro';
import { createDataSource } from 'utils/gql-datasource';
const dsGetWorkTimes = loader('./dsGetWorkTimes.gql');
export const dsWorkTimes = createDataSource(dsGetWorkTimes, {});
